import type { ReactNode } from 'react'
import { useCanAccess } from '../useCanAccess'

export interface CanAccessProps {
  resource: string
  action?: string
  record?: unknown
  children: ReactNode
  /** Rendered when access is denied. Default nothing. */
  fallback?: ReactNode
}

/** Renders its children only when the user may perform `action` on `resource` (ra-rbac semantics). */
export function CanAccess({ resource, action, record, children, fallback = null }: CanAccessProps) {
  return useCanAccess(resource, action, record) ? children : fallback
}
